import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
// import { UserProvider } from "./context/UserContext"; 
import { UserContextProvider } from "./context/UserContext";

// Layout principal
import Layout from "./Layout";

// Páginas
import HomePage from "./pages/HomePage.jsx";
import ArticlesPage from "./pages/ArticlesPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import SignInPage from "./pages/SignInPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import CreatePostPage from "./pages/CreatePostPage.jsx";
import PostDetailPage from "./pages/PostDetailPage.jsx";
import EditPostPage from "./pages/EditPostPage.jsx";

function App() {
  return (
    <UserContextProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<SignInPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/create" element={<CreatePostPage />} />
          <Route path="/post/:id" element={<PostDetailPage />} />
          <Route path="/edit/:id" element={<EditPostPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </UserContextProvider>
  );
}

export default App;